import { useState } from "react";

interface Props {
  items: string[];
  direction?: "left" | "right";
  speed?: number;
  size?: "sm" | "lg";
}

export default function Marquee({ items, direction = "left", speed = 35, size = "sm" }: Props) {
  const [isHovered, setIsHovered] = useState(false);
  const doubled = [...items, ...items, ...items];
  const fontSize = size === "lg" ? 24 : 13;

  return (
    <div style={{ overflow: "hidden", position: "relative", width: "100%" }}>
      <div
        style={{ position: "absolute", left: 0, top: 0, bottom: 0, width: 120, background: "linear-gradient(to right, #050505, transparent)", zIndex: 2, pointerEvents: "none" }}
      />
      <div
        style={{ position: "absolute", right: 0, top: 0, bottom: 0, width: 120, background: "linear-gradient(to left, #050505, transparent)", zIndex: 2, pointerEvents: "none" }}
      />
      <div
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          display: "flex",
          gap: 0,
          animation: `marquee${direction === "left" ? "Left" : "Right"} ${speed}s linear infinite`,
          animationPlayState: isHovered ? "paused" : "running",
          width: "max-content",
          cursor: "pointer",
        }}
        className="marquee-track"
      >
        {doubled.map((item, index) => (
          <span
            key={`${item}-${index}`}
            style={{
              fontFamily: "'Barlow Condensed', sans-serif",
              fontWeight: 700,
              fontSize,
              letterSpacing: "0.15em",
              color: index % 2 === 0 ? "#F8F4EC" : "#908A83",
              textTransform: "uppercase",
              padding: "0 16px",
              whiteSpace: "nowrap",
            }}
          >
            {item} <span style={{ color: "#D4A843", margin: "0 4px" }}>·</span>
          </span>
        ))}
      </div>
    </div>
  );
}
